module.exports = __webpack_public_path__ + "27246d6f97269c7510b630fb0a075213.png";